module.exports = __webpack_public_path__ + "img/sketch-white-middle.bb1c164e.png";